export default {
  // 资讯聚合
  name: 'informationAggregation',
  // 获取学术会议资讯列表
  GetListData: {
    url: '/das-api/vas/information/list'
  }
}
